//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObjectCollection.js";
import "../no/Part.js";
let d=[[],[[["interference"],"CreateInterferenceBuilder",{R_:{builder:"Motion.PackagingInterferenceBuilder"}},1,0],[["measure"],"CreateMeasureBuilder",{R_:{builder:"Motion.PackagingMeasureBuilder"}},1,0],[["trace"],"CreateTraceBuilder",{R_:{builder:"Motion.PackagingTraceBuilder"}},1,0],[["name"],"FindObject",{R_:{found:"Motion.Packaging"}},1,0],[["enableBodyOnly"],"SetDistanceMeausreBodyOnlyFilterStatus",{},1,0]],[]];
SPLM.Motion.PackagingCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Motion.PackagingCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;